import type { FC, SVGProps } from "react";
interface Props extends SVGProps<SVGSVGElement> {}
const TunningIcon: FC<Props> = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-labelledby="titleId"
      {...props}
     aria-label="tunning icon">
      {/* <title>tunning icon</title> */}
      <path
        d="M9.99996 7.29175C9.65478 7.29175 9.37496 7.01193 9.37496 6.66675V4.16675C9.37496 3.82157 9.65478 3.54175 9.99996 3.54175C10.3451 3.54175 10.625 3.82157 10.625 4.16675V6.66675C10.625 7.01193 10.3451 7.29175 9.99996 7.29175Z"
        fill={props.fill || "currentColor" || "#52565C"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.33329 6.04175C4.59895 6.04175 5.62496 7.06776 5.62496 8.33342C5.62496 9.59907 4.59895 10.6251 3.33329 10.6251C2.06764 10.6251 1.04163 9.59907 1.04163 8.33342C1.04163 7.06776 2.06764 6.04175 3.33329 6.04175ZM4.37496 8.33342C4.37496 7.75812 3.90859 7.29175 3.33329 7.29175C2.758 7.29175 2.29163 7.75812 2.29163 8.33342C2.29163 8.90871 2.758 9.37508 3.33329 9.37508C3.90859 9.37508 4.37496 8.90871 4.37496 8.33342Z"
        fill={props.fill || "currentColor" || "#52565C"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.2916 10.0001C12.2916 11.2657 11.2656 12.2917 9.99996 12.2917C8.73431 12.2917 7.70829 11.2657 7.70829 10.0001C7.70829 8.73443 8.73431 7.70842 9.99996 7.70842C11.2656 7.70842 12.2916 8.73443 12.2916 10.0001ZM9.99996 11.0417C10.5753 11.0417 11.0416 10.5754 11.0416 10.0001C11.0416 9.42479 10.5753 8.95842 9.99996 8.95842C9.42466 8.95842 8.95829 9.42479 8.95829 10.0001C8.95829 10.5754 9.42466 11.0417 9.99996 11.0417Z"
        fill={props.fill || "currentColor" || "#52565C"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.9583 11.6667C18.9583 12.9324 17.9323 13.9584 16.6666 13.9584C15.401 13.9584 14.375 12.9324 14.375 11.6667C14.375 10.4011 15.401 9.37508 16.6666 9.37508C17.9323 9.37508 18.9583 10.4011 18.9583 11.6667ZM16.6666 12.7084C17.2419 12.7084 17.7083 12.242 17.7083 11.6667C17.7083 11.0915 17.2419 10.6251 16.6666 10.6251C16.0913 10.6251 15.625 11.0915 15.625 11.6667C15.625 12.242 16.0913 12.7084 16.6666 12.7084Z"
        fill={props.fill || "currentColor" || "#52565C"}
      />
      <path
        d="M16.0416 8.33342C16.0416 8.67859 16.3214 8.95842 16.6666 8.95842C17.0118 8.95842 17.2916 8.67859 17.2916 8.33342V4.16675C17.2916 3.82157 17.0118 3.54175 16.6666 3.54175C16.3214 3.54175 16.0416 3.82157 16.0416 4.16675V8.33342Z"
        fill={props.fill || "currentColor" || "#52565C"}
      />
      <path
        d="M3.33329 11.0417C2.98811 11.0417 2.70829 11.3216 2.70829 11.6667L2.70829 15.8334C2.70829 16.1786 2.98812 16.4584 3.33329 16.4584C3.67847 16.4584 3.95829 16.1786 3.95829 15.8334L3.95829 11.6667C3.95829 11.3216 3.67847 11.0417 3.33329 11.0417Z"
        fill="#52565C"
      />
      <path
        d="M9.37496 15.8334C9.37496 16.1786 9.65478 16.4584 9.99996 16.4584C10.3451 16.4584 10.625 16.1786 10.625 15.8334V13.3334C10.625 12.9882 10.3451 12.7084 9.99996 12.7084C9.65478 12.7084 9.37496 12.9882 9.37496 13.3334V15.8334Z"
        fill={props.fill || "currentColor" || "#52565C"}
      />
      <path
        d="M16.6666 16.4584C16.3214 16.4584 16.0416 16.1786 16.0416 15.8334V15.0001C16.0416 14.6549 16.3214 14.3751 16.6666 14.3751C17.0118 14.3751 17.2916 14.6549 17.2916 15.0001V15.8334C17.2916 16.1786 17.0118 16.4584 16.6666 16.4584Z"
        fill={props.fill || "currentColor" || "#52565C"}
      />
      <path
        d="M2.70829 4.16675C2.70829 3.82157 2.98811 3.54175 3.33329 3.54175C3.67847 3.54175 3.95829 3.82157 3.95829 4.16675V5.00008C3.95829 5.34526 3.67847 5.62508 3.33329 5.62508C2.98811 5.62508 2.70829 5.34526 2.70829 5.00008V4.16675Z"
        fill={props.fill || "currentColor" || "#52565C"}
      />
    </svg>
  );
};

export default TunningIcon;
